import lodash from "lodash";
import { reactive } from "vue";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import { have } from "../../../../utils/menu-context";
import { createManageExportCsv, createPage } from "../../../../utils/page";
import { flatWhereGroup } from "../../../../utils/search";
import { createColumns } from "./infrom-o2.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/inform";
export const actionPrefixLookup = "resource/v1/master/lookup";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callSearchLookup = ({ criteria }) => store.dispatch(`${actionPrefixLookup}/search`, { criteria });

export const onSearch = ({ props, page, isSet = true }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    const companyNameThIndex = customWhere.findIndex(d => d.name === "refUserCompany.companyNameTh");
    if (companyNameThIndex !== -1) {
        const companyNameThWhere = customWhere[companyNameThIndex];
        customWhere.splice(
            companyNameThIndex,
            1,
            {
                openBucket: true,
                name: "refUserCompany.companyNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            },
            {
                logic: "OR",
                closeBucket: true,
                name: "refUserCompany.fullNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            }
        );
    }
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({
        criteria: {
            ...page,
            data: [],
            where: [...customWhere, ...createWhereFor({ props })],
            sort
        }
    })
        .then(page => (isSet ? (state.page = { ...page, where, sort }) : page))
        .finally(() => setIsLoading(false));
};

export const onSearchLookup = () => {
    setIsLoading(true);
    return callSearchLookup({
        criteria: {
            select: ["*"],
            where: [
                { name: "group", type: "String", operator: "=", value: "REPORT" },
                { name: "key", type: "String", operator: "=", value: "informO2" }
            ]
        }
    })
        .then(page => (state.lookupReport = page.data?.[0]))
        .finally(() => setIsLoading(false));
};

export const createFormTitle = () => {
    return state.lookupReport?.value;
};

export const createWhereFor = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    const departmentId = userInfo.refDepartment?.id;
    if (have({ menuContext, keys: ["customs", "province"] })) {
        whereGroup.push([
            { name: "refDepartment.id", type: "UUID", operator: "=", value: departmentId },
            { logic: "OR", name: "refDepartment.refParent.id", type: "UUID", operator: "=", value: departmentId },
            { logic: "OR", name: "refDepartment.refParent.refParent.id", type: "UUID", operator: "=", value: departmentId },
            { logic: "OR", name: "refDepartment.refParent.refParent.refParent.id", type: "UUID", operator: "=", value: departmentId }
        ]);
    }
    return [
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refRequestDoc.id", type: "UUID", operator: "=", value: "67fe2d3a-4bb7-4ec8-8150-cb57b395229b" },
        { name: "refOperation.key", type: "String", operator: "=", value: "2" },
        ...flatWhereGroup({ where: whereGroup, logic: "OR" })
    ];
};

export const initState = ({ props }) => {
    const { menuContext } = props;
    state.manages = [createManageExportCsv({
        menuContext,
        callData: ({ page }) => onSearch({ props, page: { ...lodash.cloneDeep({ ...page, page: 0, size: 1000000 }) }, isSet: false })
    })];
    state.manageExtras = [];
    state.rowActions = [];
    onSearchLookup();
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: ["*", "refUserCompany.*", "refUserCompany.refPersonType.*", "refDepartment.*", "refOperation.*", "refStatus.*", "refOriginDestinationCountry.*",
                "refInspection.id", "refInspection.approveCode",
                "refInspection.refRelease.id", "refInspection.refRelease.approveCode", "refInspection.refRelease.releaseDate",
            ],
            sort: [{ name: "updateDate", type: "DESC" }],
            children: [
                {
                    name: "products",
                    select: ["*", "refHazObject.*", "refHazSpecies.*", "refOriginDestinationCountry.*"],
                    page: 0,
                    size: 1000000,
                    children: [
                        {
                            name: "productQties",
                            select: ["*", "refQtyUnit.id", "refQtyUnit.key", "refQtyUnit.value"],
                            page: 0,
                            size: 1000000,
                            sort: [{ name: "createDate", type: "ASC" }],
                        },
                    ]
                }
            ]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    lookupReport: null
});
